// Template HTML del módulo de usuarios
import { mostrarToast, obtenerUrlBackend } from './utilerias.js';


const URL_BASE_API = obtenerUrlBackend('8083');

const API_BASE_URL = `${URL_BASE_API}/api`;

const TOKEN_KEY = 'token_teresita'; 

const templateUsuarios = `
  <div class="usuarios-container">
    <div class="usuarios-header">
      <button id="btnAgregarUsuario" class="btn btn-primary btn-icon">
        <i class="fas fa-plus"></i>
        Nuevo Usuario
      </button>
    </div>

    <div class="card">
      <div class="table-responsive">
        <table id="tablaUsuarios" class="table table-striped" style="width:100%">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Nombre</th>
              <th>Rol</th>
              <th class="text-center">Acciones</th>
            </tr>
            
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Modal Usuario -->
  <div id="modalUsuario" class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h4 id="modalTitulo">Nuevo Usuario</h4>
        <button class="modal-close" id="btnCerrarModal">&times;</button>
      </div>
      <div class="modal-body">
        <form id="formUsuario">
          <div class="form-group">
            <label for="usuario">Usuario *</label>
            <input type="text" id="usuario" name="usuario" class="form-control" required maxlength="50">
          </div>

          <div class="form-group">
            <label for="nombre">Nombre Completo *</label>
            <input type="text" id="nombre" name="nombre" class="form-control" required maxlength="100">
          </div>

          <div class="form-group">
            <label for="rol">Rol *</label>
            <select id="rol" name="rol" class="form-control" required>
              <option value="">Seleccione...</option>
              <option value="admin">Administrador</option>
              <option value="viewer">Visualizador</option>
              <option value="editor">Editor</option>
            </select>
          </div>

          <div class="form-group" id="grupoPassword">
            <label for="password">Contraseña *</label>
            <input type="password" id="password" name="password" class="form-control">
            <small class="form-text">Mínimo 6 caracteres</small>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="btnCancelar">Cancelar</button>
        <button type="submit" class="btn btn-primary" id="btnGuardar" form="formUsuario">
          <i class="fas fa-save"></i> Guardar
        </button>
      </div>
    </div>
  </div>

  <!-- Modal Confirmar Eliminación -->
  <div id="modalConfirmar" class="modal-overlay">
    <div class="modal-container modal-sm">
      <div class="modal-header modal-header-danger">
        <h3><i class="fas fa-exclamation-triangle"></i> Confirmar Eliminación</h3>
      </div>
      <div class="modal-body text-center">
        <p>¿Está seguro de que desea eliminar al usuario <strong id="nombreUsuarioEliminar"></strong>?</p>
        <p class="text-muted">Esta acción no se puede deshacer.</p>
      </div>
      <div class="modal-footer justify-center">
        <button class="btn btn-secondary" id="btnCancelarEliminar">Cancelar</button>
        <button class="btn btn-danger" id="btnConfirmarEliminar">
          <i class="fas fa-trash-alt"></i> Sí, Eliminar
        </button>
      </div>
    </div>
  </div>
`;

let tablaInstancia = null;
let usuarioActual = null;
let usuarioAEliminar = null;


function getToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}


export function paginamntoUsuario() {
  setTimeout(() => inicializarModulo(), 0);
  return templateUsuarios;
}

async function inicializarModulo() {
  await cargarUsuarios();
  bindEvents();
}

async function cargarUsuarios() {
  const token = getToken();

  debugger;

  try {
    
    const respuesta = await fetch(`${API_BASE_URL}/mntoUsuario`, {
            method: 'GET',
            headers: {
                'Authorization': token, // pase temporal
                'Content-Type': 'application/json'
            }
        });
    
    if (!respuesta.ok) throw new Error('Error al cargar usuarios');
    
    const data = await respuesta.json();
    inicializarTabla(data);
    
  } catch (error) {
    console.error('Error:', error);
    mostrarToast('Error al cargar usuarios', 'error');
  }
}

function inicializarTabla(usuariosData) {

  debugger;
  const $tabla = $('#tablaUsuarios');
  
  
  if ($.fn.DataTable.isDataTable($tabla)) {
    $tabla.DataTable().destroy();
  }
  
  
  $tabla.find('thead th').each(function() {
    
    const textoOriginal = $(this).contents().filter(function() {
      return this.nodeType === 3; // Nodos de texto
    }).text();
    
    $(this).html(textoOriginal); 
  });
  
  // ← 3. LIMPIAR tbody
  $tabla.find('tbody').empty();

  // ← 4. INICIALIZAR DataTable limpio
  tablaInstancia = $tabla.DataTable({
    responsive: true,
    language: {
      //url: '//cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json',
      "sProcessing":     "Procesando...",
        "sLengthMenu":     "Mostrar _MENU_ registros",
        "sZeroRecords":    "No se encontraron resultados",
        "sEmptyTable":     "Ningún dato disponible en esta tabla",
        "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
        "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
        "sSearch":         "Buscar:",
        "sInfoThousands":  ",",
        "sLoadingRecords": "Cargando...",
        "oPaginate": {
            "sFirst":    "Primero",
            "sLast":     "Último",
            "sNext":     "Siguiente",
            "sPrevious": "Anterior"
        },
        "oAria": {
            "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
            "sSortDescending": ": Activar para ordenar la columna de manera descendente"
        },
      emptyTable: "No hay usuarios registrados",
      zeroRecords: "No se encontraron coincidencias"
    },
    data: usuariosData,
    columns: [
      { data: 'usuario', width: '25%', searchable: true },
      { data: 'nombre', width: '40%', searchable: true },
      { data: 'rol', width: '20%', searchable: true, render: renderRol },
      { 
        data: null, 
        width: '15%', 
        orderable: false, 
        searchable: false,
        className: 'text-center',
        render: renderAcciones
      }
    ],
    initComplete: function () {
      this.api().columns().every(function (index) { 
        var column = this;
        var title = $(column.header()).text();
        
        if (column.settings()[0].aoColumns[index].bSearchable === false) {
          return;
        }

        var input = $('<input type="text" class="filtro-columna form-control form-control-sm" placeholder="Filtrar ' + title + '" />')
          .appendTo($(column.header()))
          .on('keyup change clear', function () {
            if (column.search() !== this.value) {
              column.search(this.value).draw();
            }
          })
          .on('click', function(e) {
            e.stopPropagation();
          });
      });
      
      var contenedor = document.getElementById('estado-contenedor');
      if (contenedor) {
        contenedor.style.display = 'none';
      }
    },
    order: [[1, 'asc']],
    pageLength: 10,
    lengthMenu: [[5, 10, 25, 50], [5, 10, 25, 50]],
    dom: 'rtip'
  });
}

function renderRol(data) {
  const roles = {
    'admin': 'Administrador',
    'editor': 'Editor',
    'viewer': 'Visualizador'
  };
  return roles[data] || data;
}

function renderAcciones(data) {
  return `
    <div class="acciones-cell">
      <button class="btn-action btn-edit" data-usuario="${data.usuario}" title="Editar">
        <i class="fas fa-pencil-alt"></i>
      </button>
      <button class="btn-action btn-delete" data-usuario="${data.usuario}" data-nombre="${data.nombre}" title="Eliminar">
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
  `;
}

function bindEvents() {
  debugger;
  $('#btnAgregarUsuario').off('click').on('click', abrirModalAgregar);

  $('#tablaUsuarios tbody').off('click').on('click', '.btn-edit', function(e) {
    e.preventDefault();
    const usuario = $(this).data('usuario');
    abrirModalEditar(usuario);
  });

  $('#tablaUsuarios tbody').on('click', '.btn-delete', function(e) {
    e.preventDefault();
    const usuario = $(this).data('usuario');
    const nombre = $(this).data('nombre');
    abrirModalEliminar(usuario, nombre);
  });

  $('#formUsuario').off('submit').on('submit', function(e) {
    e.preventDefault();
    guardarUsuario();
  });

  $('#btnCerrarModal, #btnCancelar').off('click').on('click', cerrarModal);
  $('#btnCancelarEliminar').off('click').on('click', cerrarModalEliminar);
  $('#btnConfirmarEliminar').off('click').on('click', eliminarUsuario);

  $('.modal-overlay').off('click').on('click', function(e) {
    if ($(e.target).hasClass('modal-overlay')) {
      cerrarModal();
      cerrarModalEliminar();
    }
  });
}

function abrirModalAgregar() {
  usuarioActual = null;
  $('#modalTitulo').text('Nuevo Usuario');
  $('#formUsuario')[0].reset();
  $('#usuario').prop('disabled', false);
  $('#grupoPassword').show();
  $('#password').attr('required', true);
  $('#modalUsuario').addClass('active');
  $('#usuario').focus();
}

async function abrirModalEditar(usuario) {
  const token = getToken();
  
  try {
    // Endpoint con /mntoUsuario
    const response = await fetch(`${API_BASE_URL}/mntoUsuario/${usuario}`, {
      headers: { 
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) throw new Error(`Error ${response.status}`);
    
    // ← La respuesta viene directamente, no anidada en "data"
    const usuarioData = await response.json();
    
    usuarioActual = usuario; // Guardar para el PUT
    
    $('#modalTitulo').text('Editar Usuario');
    $('#usuario').val(usuarioData.usuario).prop('disabled', true);
    $('#nombre').val(usuarioData.nombre);
    $('#rol').val(usuarioData.rol);
    
    $('#grupoPassword').hide();
    $('#password').attr('required', false).val('');
    
    $('#modalUsuario').addClass('active');
    $('#nombre').focus();
    
  } catch (error) {
    console.error('Error:', error);
    mostrarToast('Error al cargar usuario: ' + error.message, 'error');
  }
}

function cerrarModal() {
  $('#modalUsuario').removeClass('active');
  $('#formUsuario')[0].reset();
  usuarioActual = null;
}

async function guardarUsuario() {
  const token = getToken();
  
  const datos = {
    usuario: $('#usuario').val().trim(),
    nombre: $('#nombre').val().trim(),
    rol: $('#rol').val()
  };

  if (!datos.usuario || !datos.nombre || !datos.rol) {
    mostrarToast('Complete todos los campos obligatorios', 'error');
    return;
  }

  const esNuevo = !usuarioActual;
  const method = esNuevo ? 'POST' : 'PUT';

  if (esNuevo) {
    datos.password = $('#password').val();
    if (!datos.password || datos.password.length < 6) {
      mostrarToast('La contraseña debe tener al menos 6 caracteres', 'error');
      return;
    }
  }

  debugger;
  
  try {
    // ← CORREGIDO: Construir URL según sea POST o PUT
    const url = esNuevo 
      ? `${API_BASE_URL}/mntoUsuario`           // POST: sin /usuario
      : `${API_BASE_URL}/mntoUsuario/${usuarioActual}`;  // PUT: con /usuarioActual

    const response = await fetch(url, {
      method: method,
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(datos)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || error.message || 'Error al guardar');
    }

    mostrarToast(
      esNuevo ? 'Usuario creado correctamente' : 'Usuario actualizado correctamente',
      'success'
    );
    
    cerrarModal();
    await cargarUsuarios();

   
    
  } catch (error) {
    mostrarToast(error.message, 'error');
  }
}

function abrirModalEliminar(usuario, nombre) {
  usuarioAEliminar = usuario;
  $('#nombreUsuarioEliminar').text(nombre);
  $('#modalConfirmar').addClass('active');
}

function cerrarModalEliminar() {
  $('#modalConfirmar').removeClass('active');
  usuarioAEliminar = null;
}

async function eliminarUsuario() {
  debugger;
  if (!usuarioAEliminar) return;
  
  const token = getToken();

  try {
    const response = await fetch(`${API_BASE_URL}/mntoUsuario/${usuarioAEliminar}`, {
      method: 'DELETE',
      headers: { 
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      
      
      if (response.status === 404) {
        throw new Error('Usuario no encontrado');
      } else if (response.status === 409) {
        throw new Error(errorData.error || 'El usuario tiene registros relacionados');
      } else {
        throw new Error(errorData.error || `Error ${response.status} al eliminar`);
      }
    }

    const data = await response.json();
    
    mostrarToast(data.mensaje || 'Usuario eliminado correctamente', 'success');
    cerrarModalEliminar();
    await cargarUsuarios();
    
  } catch (error) {
    console.error('Error al eliminar:', error);
    mostrarToast(error.message || 'Error al eliminar usuario', 'error');
  } finally {
    
    usuarioAEliminar = null;
  }
}

